import React, { useState, useEffect } from 'react';
import '../styles/components.css';

const getStyleDisplayName = (style, gameState) => {
    console.log('Style input:', style);
    console.log('GameState:', gameState);
    console.log('Current Image Style:', gameState?.currentImage?.style);

    // First check if we have a generated style in currentImage
    if (gameState?.currentImage?.style) {
        console.log('Returning currentImage.style:', gameState.currentImage.style);
        return gameState.currentImage.style;
    }

    // For predefined styles, map them to their display names
    const styleMap = {
        'expression': 'Expression',
        'abstract': 'Abstract',
        'surreal': 'Surreal',
        'naive': 'Naïve',
        'minimal': 'Minimal',
        'anime': 'Anime',
        'ink': 'Ink',
        'random': 'Random'
    };

    const mappedStyle = styleMap[style] || style;
    console.log('Returning mapped style:', mappedStyle);
    return mappedStyle;
};

const RevealOverlay = ({
    isVisible,
    prompt,
    guesses,
    players,
    imageUrl,
    onClose,
    roundScores,
    isPromptGiver,
    onNextRound,
    gameState
}) => {
    const [stage, setStage] = useState('initial');
    const [showContent, setShowContent] = useState(false);

    useEffect(() => {
        if (isVisible) {
            // Start the reveal sequence
            setShowContent(true);
            setStage('initial');

            const promptTimer = setTimeout(() => setStage('prompt'), 1000);
            const guessesTimer = setTimeout(() => setStage('guesses'), 1500);
            const completeTimer = setTimeout(() => setStage('complete'), 2000);

            return () => {
                clearTimeout(promptTimer);
                clearTimeout(guessesTimer);
                clearTimeout(completeTimer);
            };
        } else {
            // Reset state when overlay is hidden
            setShowContent(false);
            setStage('initial');
        }
    }, [isVisible]);

    // Don't render anything if not visible
    if (!isVisible) return null;

    return (
        <div className="reveal-overlay">
            <div className="reveal-content">
                {showContent && (
                    <>
                        <div className={`reveal-stage ${stage}`}>
                            {/* Image Display */}
                            <div className="reveal-image-container">
                                <img src={imageUrl} alt="Generated Art" className="reveal-image" />
                            </div>

                            {/* Prompt Reveal */}
                            <div className="reveal-prompt-section">
                                <div className="reveal-prompt-label"><strong>{gameState?.promptGiver?.name}</strong>'s  {gameState?.currentImage?.style || getStyleDisplayName(gameState?.settings?.artStyle, gameState)} Art</div>
                                <div className="reveal-prompt-text">
                                    <span className="reveal-quote">"</span>
                                    {prompt}
                                    <span className="reveal-quote">"</span>
                                </div>

                            </div>

                            {/* Guesses Display */}
                            <div className="reveal-guesses-section">
                                {guesses.map((guess, index) => {
                                    const player = players.find(p => p.id === guess.playerId);
                                    const isExactMatch = guess.guess.toLowerCase() === prompt.toLowerCase();
                                    const badge = roundScores?.[guess.playerId]?.badge;

                                    return (
                                        <div
                                            key={guess.playerId}
                                            className={`reveal-guess-item ${isExactMatch ? 'exact-match' : ''}`}
                                            style={{ animationDelay: `${2.5 + index * 0.2}s` }}
                                        >
                                            <div className="reveal-player-info">
                                                <span className="reveal-player-name"><strong>{player?.name}</strong> thinks it's:</span>

                                                <div className="reveal-guess-text">"{guess.guess}"</div>

                                            </div>
                                            {badge && (
                                                <span className={`reveal-badge ${isExactMatch ? 'perfect' : ''}`}>
                                                    {badge}
                                                </span>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Next Round Button - Only show to the current prompt giver when stage is complete */}
                        {stage === 'complete' && isPromptGiver && (
                            <button
                                className="reveal-next-round-button"
                                onClick={() => {
                                    onNextRound();
                                    // No need to call onClose() here as it will be handled by the game state change
                                }}
                            >
                                Next Round
                            </button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default RevealOverlay; 